import { PageQuestionsItem } from '../../types'

const validate = (question: PageQuestionsItem) => (value: string) => {
  if (!value && question.isRequired) {
    return question.questionsDisplayContent[0].answerRequiredErrorText || 'Required'
  }

  if (value && question.validationRegEx) {
    const pattern = question.validationRegEx.substring(1, question.validationRegEx.length - 1)
    const re = new RegExp(pattern)
    if (!re.test(value)) {
      return question.questionsDisplayContent[0].answerFormatErrorText || 'Bad Format'
    }
  }

  return ''
}

export default validate
